import { useUnitTranslation } from '@/shared/contexts/TranslationContext'

interface Invitation {
  id: string
  unit_name: string
  role: 'admin' | 'manager' | 'viewer'
}

interface InvitationsListProps {
  invitations: Invitation[]
  onAccept: (inviteId: string) => void
  onDecline: (inviteId: string) => void
}

export function InvitationsList({ invitations, onAccept, onDecline }: InvitationsListProps) {
  const { tu } = useUnitTranslation()

  if (invitations.length === 0) {
    return null
  }

  const getRoleLabel = (role: string) => {
    switch (role) {
      case 'admin':
        return tu('list.admin')
      case 'manager':
        return tu('list.manager')
      default:
        return tu('list.viewer')
    }
  }

  return (
    <div className="mb-8">
      <h2 className="text-xl font-semibold text-slate-900 dark:text-white mb-4">
        {tu('list.pendingInvitations')}
      </h2>
      <div className="bg-white dark:bg-slate-800 rounded-lg border border-yellow-200 dark:border-yellow-900/50 shadow-sm overflow-hidden">
        <ul className="divide-y divide-gray-200 dark:divide-gray-700">
          {invitations.map((invite) => (
            <li 
              key={invite.id} 
              className="p-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4"
            >
              <div>
                <p className="font-medium text-slate-900 dark:text-white">
                  {tu('list.invitationToManage')} <strong>{invite.unit_name}</strong>
                </p>
                <p className="text-sm text-slate-500 dark:text-slate-400">
                  {tu('list.as')} <span className="capitalize">{getRoleLabel(invite.role)}</span>
                </p>
              </div>
              <div className="flex gap-2">
                <button
                  onClick={() => onAccept(invite.id)}
                  className="px-4 py-2 bg-emerald-600 text-white text-sm font-medium rounded-lg hover:bg-emerald-700 transition-colors"
                >
                  {tu('list.accept')}
                </button>
                <button
                  onClick={() => onDecline(invite.id)}
                  className="px-4 py-2 bg-white dark:bg-slate-700 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-200 text-sm font-medium rounded-lg hover:bg-gray-50 dark:hover:bg-slate-600 transition-colors"
                >
                  {tu('list.decline')}
                </button>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
